/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ChoiceInfo } from './ChoiceInfo';
import {
    ChoiceInfoFromJSON,
    ChoiceInfoFromJSONTyped,
    ChoiceInfoToJSON,
} from './ChoiceInfo';
import type { Command } from './Command';
import {
    CommandFromJSON,
    CommandFromJSONTyped,
    CommandToJSON,
} from './Command';
import type { ReferenceItem } from './ReferenceItem';
import {
    ReferenceItemFromJSON,
    ReferenceItemFromJSONTyped,
    ReferenceItemToJSON,
} from './ReferenceItem';

/**
 * 
 * @export
 * @interface Choice
 */
export interface Choice {
    /**
     * 
     * @type {Command}
     * @memberof Choice
     */
    autoCompletionCommand?: Command;
    /**
     * 
     * @type {ChoiceInfo}
     * @memberof Choice
     */
    choiceInfo?: ChoiceInfo;
    /**
     * 
     * @type {Array<ReferenceItem>}
     * @memberof Choice
     */
    itemOptions: Array<ReferenceItem>;
    /**
     * 
     * @type {boolean}
     * @memberof Choice
     */
    nonSuggestedValuesAllowed?: boolean;
}

/**
 * Check if a given object implements the Choice interface.
 */
export function instanceOfChoice(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "itemOptions" in value;

    return isInstance;
}

export function ChoiceFromJSON(json: any): Choice {
    return ChoiceFromJSONTyped(json, false);
}

export function ChoiceFromJSONTyped(json: any, ignoreDiscriminator: boolean): Choice {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'autoCompletionCommand': !exists(json, 'autoCompletionCommand') ? undefined : CommandFromJSON(json['autoCompletionCommand']),
        'choiceInfo': !exists(json, 'choiceInfo') ? undefined : ChoiceInfoFromJSON(json['choiceInfo']),
        'itemOptions': ((json['itemOptions'] as Array<any>).map(ReferenceItemFromJSON)),
        'nonSuggestedValuesAllowed': !exists(json, 'nonSuggestedValuesAllowed') ? undefined : json['nonSuggestedValuesAllowed'],
    };
}

export function ChoiceToJSON(value?: Choice | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'autoCompletionCommand': CommandToJSON(value.autoCompletionCommand),
        'choiceInfo': ChoiceInfoToJSON(value.choiceInfo),
        'itemOptions': ((value.itemOptions as Array<any>).map(ReferenceItemToJSON)),
        'nonSuggestedValuesAllowed': value.nonSuggestedValuesAllowed,
    };
}

